module.exports = __webpack_public_path__ + "media/images/case_image01-b406ce57.svg";